// File des extractions demandées hors réseau (IndexedDB). Au retour du réseau, chaque demande part avec
// ajouter_aux_documents : le fichier rejoint les Documents de la parcelle, puisque personne n'attend le téléchargement.
import { authFetch } from "@/lib/api";

const DB_NAME = "veyerciel-extractions";
const STORE = "demandes";
export const QUEUE_EVENT = "veyerciel-extractions";
const API = process.env.REACT_APP_BACKEND_URL + "/api";

function openDb() {
  return new Promise((resolve, reject) => {
    if (typeof indexedDB === "undefined") return reject(new Error("IndexedDB indisponible"));
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => req.result.createObjectStore(STORE, { keyPath: "id" });
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

function run(mode, fn) {
  return openDb().then((db) => new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, mode);
    const req = fn(tx.objectStore(STORE));
    tx.oncomplete = () => { db.close(); resolve(req?.result); };
    tx.onerror = () => { db.close(); reject(tx.error); };
  }));
}

const notifier = () => window.dispatchEvent(new Event(QUEUE_EVENT));

export async function mettreEnFile(parcelId, body) {
  const id = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  await run("readwrite", (s) => s.put({ id, parcelId, body: { ...body, ajouter_aux_documents: true }, created_at: new Date().toISOString() }));
  notifier();
}

export async function demandesEnFile(parcelId) {
  try {
    const all = (await run("readonly", (s) => s.getAll())) || [];
    return parcelId ? all.filter((d) => d.parcelId === parcelId) : all;
  } catch {
    return [];
  }
}

let enCours = false;

// Envoie les demandes en attente ; s'arrête à la première erreur réseau. Renvoie les demandes abouties.
export async function viderFile() {
  if (enCours || !navigator.onLine) return [];
  enCours = true;
  const faites = [];
  try {
    for (const d of await demandesEnFile()) {
      let res;
      try {
        res = await authFetch(`${API}/parcels/${encodeURIComponent(d.parcelId)}/extraction`, {
          method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(d.body),
        });
      } catch {
        break; // toujours hors réseau
      }
      if (res.status === 401 || res.status >= 500) break; // à réessayer plus tard
      await run("readwrite", (s) => s.delete(d.id));
      faites.push({ ...d, ok: res.ok, documentId: res.headers.get("X-Document-Id") });
    }
  } finally {
    enCours = false;
    notifier();
  }
  return faites;
}
